var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0913 4.30886L11.099 0L4.87812 3.58889L4.87044 7.89681L11.0913 4.30886Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27899 8.93002L9.27789 7.05809L10.9007 7.99437L9.27899 8.93002Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1006 12.412L11.1082 8.10319L4.88737 11.6921L4.87969 16L11.1006 12.412Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07355 8.01948L6.72335 8.97109L6.72225 7.06857L5.07355 8.01948Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6714 8.01459C1.6714 4.93534 3.86979 2.36956 6.78267 1.80113L8.16147 1.00438C8.10853 1.0032 8.05544 1.0026 8.00222 1.0026C4.12961 1.0026 0.990234 4.14198 0.990234 8.01459C0.990234 10.5237 2.30807 12.7249 4.28935 13.964L4.29081 13.144C2.70369 11.9936 1.6714 10.1246 1.6714 8.01459Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14167 14.2431L7.79097 15.0234C7.86113 15.0255 7.93155 15.0266 8.00222 15.0266C11.8748 15.0266 15.0142 11.8872 15.0142 8.01459C15.0142 5.49719 13.6876 3.28964 11.6954 2.05287L11.6939 2.87097C13.2922 4.02012 14.333 5.8958 14.333 8.01459C14.333 11.122 12.0943 13.7065 9.14167 14.2431Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSport);
export default __webpack_public_path__ + "static/media/sport.29e068340b11b6b296010131bda7661e.svg";
export { ForwardRef as ReactComponent };